import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { StructureController, TerraceDesignToolsController } from 'cd-eft/services/eftSetApi';

const {projectsLibraryStore} = stores.AppStore;

export class PrintDesignReportsVM {
  @observable props;

  constructor(props) {
    this.props = props;
  }

  @observable waterwayDesignReportData: any;
  @observable terraceDesignReportObj:any;

  @action.bound async getTerraceSummaryReport(printButtonClicked) {
     if (printButtonClicked) {
      projectsLibraryStore.isReportGenerated = false;
    const allignedElementDesignParamsIdArray : any[]=[];
    projectsLibraryStore.designElementsByType['Terrace']?.designElements
    .filter((el) => el.isSelected)
    .map((el: any) => {
      if (el.alignedElementDesignParamsId) {
        allignedElementDesignParamsIdArray.push(el.alignedElementDesignParamsId);
      }
    });
    try {
      let jsonData: any[]=[];
      if (allignedElementDesignParamsIdArray.length > 0) {
          for (const elementId of allignedElementDesignParamsIdArray) {
          const reportValues = await TerraceDesignToolsController.getTerraceDesignReportUsingGET(elementId);
          jsonData.push(reportValues.data)
      }
      }
      this.terraceDesignReportObj = jsonData ;
      projectsLibraryStore.isReportGenerated = true;
    }
    catch (err) {
      console.error('error: getWaterwaySummaryReport()', err)
    }
  }}

  @action.bound async generateWaterwayDesignReport(printButtonClicked) {
    if (printButtonClicked) {
      projectsLibraryStore.isReportGenerated = false;

      if (this.props.project.sessionList) {
        const grassArray: any[] = [];
        const linedArray: any[] = [];
        const designReportPayload = {
          elementTypeAndIdListMap: { 7: grassArray, 19: linedArray },
          sessionUuid: this.props.project.sessionList[0].sessionUuid,
        };
        projectsLibraryStore.designElementsByType['Waterway']?.designElements
          .filter((el) => el.isSelected)
          .map((el: any) => {
            if (el.alignedElementDesignParamsId) {
              if (el.waterwayType === 'Grassed') grassArray.push(el.alignedElementDesignParamsId);
              if (el.waterwayType === 'Lined') linedArray.push(el.alignedElementDesignParamsId);
            }
          });
      if(grassArray.length > 0 || linedArray.length > 0){
        const designReportResponse = await StructureController.collectDesignReportsUsingPOST(
          designReportPayload
        );
        if (
          designReportResponse &&
          designReportResponse.data &&
          designReportResponse.data.elementTypeAndReportListMap
        ) {
          let jsonData: any[] = [];
          Object.values(designReportResponse.data.elementTypeAndReportListMap).forEach((value) => {
            jsonData = [...jsonData, ...value];
          });

          this.waterwayDesignReportData = jsonData;
        }
    }else{this.waterwayDesignReportData = {}}
      }
      projectsLibraryStore.isReportGenerated = true;
    }
  }
}
